/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gads_HintInputs */

const cs_integrations_gads_hint = /** @type {(inputs: Integrations_Gads_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte refresh token (scope adwords) a customer ID — kampaně se pozastaví při prodeji/pronájmu.`)
};

const en_integrations_gads_hint = /** @type {(inputs: Integrations_Gads_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste an Ads refresh token (adwords scope) and customer ID to auto-pause campaigns when a listing is sold/rented.`)
};

/**
* | output |
* | --- |
* | "Paste an Ads refresh token (adwords scope) and customer ID to auto-pause campaigns when a listing is sold/rented." |
*
* @param {Integrations_Gads_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gads_hint = /** @type {((inputs?: Integrations_Gads_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gads_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gads_hint(inputs)
	return cs_integrations_gads_hint(inputs)
});